theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const MobileMenu = function () {
      const offcanvasOpenBtns = document.querySelectorAll(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenuAll = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      /* Overlay scuro sopra l'header (z:9998 < offcanvas-header z:9999) */
      var _menuOverlay = null;
      function getMenuOverlay() {
        if (!_menuOverlay) {
          _menuOverlay = document.createElement('div');
          _menuOverlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9998;';
          document.body.appendChild(_menuOverlay);
        }
        return _menuOverlay;
      }

      /* Blocco scroll universale: iOS Safari, Android, desktop */
      var _scrollY = 0;
      function lockScroll() {
        _scrollY = window.scrollY || window.pageYOffset;
        var h = document.documentElement;
        h.style.overflow = 'hidden';
        h.style.height   = '100%';
        h.style.overscrollBehavior = 'none';
        body.style.overflow  = 'hidden';
        body.style.height    = '100%';
        body.style.position  = 'fixed';
        body.style.top       = '-' + _scrollY + 'px';
        body.style.width     = '100%';
        body.style.overscrollBehavior = 'none';
      }
      function unlockScroll() {
        /* scrollTo solo se il body era realmente bloccato: il listener
           globale chiama unlockScroll a ogni click e senza questa guardia
           la pagina saltava in alto prima di navigare su qualsiasi link */
        var wasLocked = body.style.position === 'fixed';
        var h = document.documentElement;
        h.style.overflow = '';
        h.style.height   = '';
        h.style.overscrollBehavior = '';
        body.style.overflow  = '';
        body.style.height    = '';
        body.style.position  = '';
        body.style.top       = '';
        body.style.width     = '';
        body.style.overscrollBehavior = '';
        if (wasLocked) window.scrollTo(0, _scrollY);
      }

      /* Open/Close Menu On Click Toggle Button — supporta più bottoni (mobile + catalogo desktop) */
      offcanvasOpenBtns.forEach(function (offcanvasOpen) {
        offcanvasOpen.addEventListener("click", function (e) {
          e.preventDefault();
          offcanvasHeader.classList.add("open");
          lockScroll();
          body.classList.add("added__overlay");
          getMenuOverlay().style.display = 'block';
        });
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.remove("open");
        unlockScroll();
        body.classList.remove("added__overlay");
        getMenuOverlay().style.display = 'none';
      });
      /* Open/Close Sub Menu On Click Toggle Button */

      if (offcanvasMenuAll.length > 0) {
        offcanvasMenuAll.forEach((offcanvasMenu) => {
          /* Add a Button For SubMenu Toggle */
          offcanvasMenu
            .querySelectorAll(".offcanvas__sub_menu")
            .forEach(function (ul) {
              const subMenuToggle = document.createElement("button");
              subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
              subMenuToggle.setAttribute("aria-label", "menu collapse");
              ul.parentNode.appendChild(subMenuToggle);
            });

          /* Submenu toggle */
          offcanvasMenu
            .querySelectorAll(".offcanvas__sub_menu_toggle")
            .forEach(function (toggle) {
              toggle.addEventListener("click", function (e) {
                e.preventDefault();
                const parent = this.parentElement;
                if (parent.classList.contains("active")) {
                  this.classList.remove("active");
                  parent.classList.remove("active");
                  parent
                    .querySelectorAll(".offcanvas__sub_menu")
                    .forEach(function (subMenu) {
                      subMenu.parentElement.classList.remove("active");
                      subMenu.nextElementSibling.classList.remove("active");
                      slideUp(subMenu);
                    });
                } else {
                  this.classList.add("active");
                  parent.classList.add("active");
                  slideDown(this.previousElementSibling);
                  getSiblings(parent).forEach(function (item) {
                    item.classList.remove("active");
                    item
                      .querySelectorAll(".offcanvas__sub_menu")
                      .forEach(function (subMenu) {
                        subMenu.parentElement.classList.remove("active");
                        subMenu.nextElementSibling.classList.remove("active");
                        slideUp(subMenu);
                      });
                  });
                }
              });
            });
        });
      }

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            offcanvasHeader.classList.remove("open");
            unlockScroll();
            body.classList.remove("added__overlay");
            if (_menuOverlay) _menuOverlay.style.display = 'none';
          }
        }
      });

      /* Chiudi offcanvas solo se si scende sotto 992px (resize da desktop a mobile) */
      let lastWidth = window.outerWidth;
      window.addEventListener("resize", function () {
        const w = window.outerWidth;
        if (lastWidth >= 992 && w < 992) {
          offcanvasHeader.classList.remove("open");
          unlockScroll();
          body.classList.remove("added__overlay");
          if (_menuOverlay) _menuOverlay.style.display = 'none';
        }
        lastWidth = w;
      });
    };
    /* Mobile Menu Active */
    MobileMenu();

    /* Menu toggle buttons */
    const mobileMenuToggleButtons = document.querySelectorAll(
      ".mobile--menu-header-button"
    );
    const mobileMainMenu = document.querySelector(".mobile__main-menu--list");
    const mobileVerticalMenu = document.querySelector(
      ".mobile__categories--list"
    );
    if (mobileMenuToggleButtons.length > 0) {
      mobileMenuToggleButtons.forEach((button) => {
        button?.addEventListener("click", function (e) {
          mobileMenuToggleButtons.forEach((childButton) => {
            childButton.classList.remove("active");
          });
          if (button.classList.contains("mobile__main--menu")) {
            button.classList.add("active");
            if (mobileMainMenu.classList.contains("d-none")) {
              mobileMainMenu.classList.remove("d-none");
            }
            mobileVerticalMenu.classList.add("d-none");
          }
          if (button.classList.contains("mobile__categories--menu")) {
            button.classList.add("active");
            if (mobileVerticalMenu.classList.contains("d-none")) {
              mobileVerticalMenu.classList.remove("d-none");
            }
            mobileMainMenu.classList.add("d-none");
          }
        });
      });
    }
  }

  return header;
})();
